// src/Component/hooks/useUpdateDetail_pengeluaran.jsx
import { useState } from 'react';
import api from '../Services/api';
import endpoints from '../Services/endpointAdmin';

/**
 * usePutDetailPengeluaran adalah custom hook yang digunakan untuk memperbarui data detail pengeluaran di backend.
 * @returns { Object } - Mengembalikan fungsi putDetailPengeluaran, serta status loading dan error.
 */
const usePutDetailPengeluaran = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  /**
   * Fungsi untuk memperbarui data detail pengeluaran di backend.
   * @param { number } id - ID detail pengeluaran yang akan diperbarui.
   * @param { number } id_jenis_beban
   * @param { number } nominal
   * @param { string } keterangan
   * @param { number|null } id_pengeluaran
   * @returns { Promise<Object> } - Mengembalikan data respons dari backend atau error.
   */
  const putDetailPengeluaran = async (id, id_jenis_beban, nominal, keterangan, id_pengeluaran = null) => {
    setLoading(true);
    setError(null);

    try {
      const data = {
        id_jenis_beban,
        nominal,
        keterangan,
      };
      if (id_pengeluaran != null) {
        data.id_pengeluaran = id_pengeluaran;
      }

      if (!endpoints.detail_pengeluaran || typeof endpoints.detail_pengeluaran.update !== 'function') {
        throw new Error('endpoints.detail_pengeluaran.update is not defined');
      }

      const response = await api.put(endpoints.detail_pengeluaran.update(id), data, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (err) {
      console.error('Error updating detail pengeluaran:', err);
      setError(
        err.response?.data?.error ||
        err.response?.data?.message ||
        err.message ||
        'Terjadi kesalahan saat memperbarui detail pengeluaran.'
      );
      return null;
    } finally {
      setLoading(false);
    }
  };

  return { putDetailPengeluaran, loading, error };
};

export default usePutDetailPengeluaran;
